import React, { useEffect, useRef } from 'react';
import Highlighter from '../../Inputs/Highlighter';
import CheckRadioList from './CheckRadioList';
import CheckList from '../../Inputs/CheckList';

export const CheckboxTreeItem = ({
  closeDDM,
  closeOnBlurDDM,
  parentObj,
  isOpened,
  highlightSearch,
  singleSelect,
  selectedIds,
  onSelect,
  hideChild,
  showChild,
  isAutoExpend,
  focus,
  positionIndex,
  setFocusPosition,
  treeItemsSize,
  hasContainerFocus,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (focus.focusIndex === positionIndex && focus.focusInnerIndex === -1 && hasContainerFocus) {
      ref.current.focus();
    }
  }, [focus.focusIndex, focus.focusInnerIndex, hasContainerFocus]);

  const moveFocusUp = () => {
    --focus.focusIndex;
  };

  const moveFocusDown = () => {
    if (focus.focusIndex !== treeItemsSize - 1) {
      if (isOpened) {
        focus.focusInnerIndex = 0;
      } else {
        focus.focusIndex = ++focus.focusIndex;
      }
    } else if (isOpened) {
      focus.focusInnerIndex = 0;
    }
  };

  const handleOnClick = (e) => {
    e.stopPropagation();
    setFocusPosition({ focusIndex: positionIndex, focusInnerIndex: -1 });
    if (!hasContainerFocus) {
      setTimeout(() => {
        isOpened ? hideChild(parentObj.casId) : showChild(parentObj.casId);
      }, 1);
    } else {
      isOpened ? hideChild(parentObj.casId) : showChild(parentObj.casId);
    }
  };

  const handleOnKeyDown = (e) => {
    const { key } = e;

    if (focus.focusInnerIndex !== -1) return;
    switch (key) {
      case 'Enter':
        isOpened ? hideChild(parentObj.casId) : showChild(parentObj.casId);
        break;
      case 'ArrowLeft':
        hideChild(parentObj.casId);
        break;
      case 'ArrowRight':
        showChild(parentObj.casId);
        if (isOpened) {
          focus.focusInnerIndex = 0;
        }
        break;
      case 'ArrowUp':
        moveFocusUp();
        break;
      case 'ArrowDown':
        moveFocusDown();
        break;
      case 'Escape':
        closeDDM();
        break;
      case ' ':
        isOpened ? hideChild(parentObj.casId) : showChild(parentObj.casId);
        break;
      default:
    }

    setFocusPosition(focus);
  };

  return (
    <li
      role="menuitem"
      key={parentObj.casId}
      aria-expanded={isOpened}
      aria-label={`cas ${parentObj.name} with ${parentObj.clients.length} organization`}>
      <div
        ref={ref}
        aria-label={`${parentObj.name}`}
        role="checkbox"
        aria-checked={isOpened}
        tabIndex={focus.focusInnerIndex === -1 ? '0' : '-1'}
        onBlur={closeOnBlurDDM}
        onClick={handleOnClick.bind(this)}
        onKeyDown={handleOnKeyDown.bind(this)}>
        {singleSelect && isAutoExpend ? null : (
          <i className={`far fa-${isOpened ? 'minus' : 'plus'}-square cb-toggle-icon`}></i>
        )}
        <label>
          <Highlighter textToHighlight={parentObj.name} searchWords={highlightSearch} />
        </label>
      </div>

      {singleSelect ? (
        <CheckRadioList
          items={parentObj.clients}
          selectedId={selectedIds[0]}
          focus={focus}
          setFocusPosition={setFocusPosition}
          parentPositionIndex={positionIndex}
          hasContainerFocus={hasContainerFocus}
          parentItemsSize={treeItemsSize}
          closeDDM={closeDDM}
          closeOnBlurDDM={closeOnBlurDDM}
          onSelect={(item) => {
            const casOrgDetails = {
              casId: parentObj.casId,
              name: parentObj.name,
              clientName: item.name,
              clientId: item.id,
            };
            onSelect(casOrgDetails);
          }}
          classNames={isOpened ? 'unfolded auto-expand' : 'folded'}
        />
      ) : (
        <CheckList
          highlightSearch={highlightSearch}
          items={parentObj.clients}
          selectedIds={selectedIds}
          onSelectCheckbox={(item) => onSelect(item)}
          classNames={isOpened ? 'unfolded' : 'folded'}
        />
      )}
    </li>
  );
};

export default CheckboxTreeItem;
